import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Inventory from "./Inventory";
import Dashboard from "./Dashboard";
import AssetRegister from "./assetregister";
import AssetTracking from "./assettracking";
import Staff from "./staff";
import Users from "./users";

const MainContent = ({ activeTab, setActiveTab }) => {
  const [productCount, setProductCount] = useState(0);
  const [trackedAssetCount, setTrackedAssetCount] = useState(0);
  const [assets, setAssets] = useState([]);
  const [products, setProducts] = useState([]);
  const [setInventory] = useState([]);

  const navigate = useNavigate();

  useEffect(() => {
    if (activeTab === "Logout") {
      navigate("/Logout");
    }
  }, [activeTab, navigate]);

  useEffect(() => {
    setProductCount(products.length);
  }, [products]);

  const updateTrackedAssetCount = (count) => {
    setTrackedAssetCount(count);
  };

  const renderActiveTab = () => {
    switch (activeTab) {
      case "Dashboard":
        return (
          <Dashboard
            products={products}
            productCount={productCount}
            trackedAssetCount={trackedAssetCount}
            setActiveTab={setActiveTab}
          />
        );
      case "Asset Register":
        return (
          <AssetRegister
            products={products}
            setProducts={setProducts}
            setInventory={setInventory}
          />
        );
      case "Inventory":
        return (
          <Inventory
            products={products}
            setProducts={setProducts}
            setProductCount={setProductCount}
            setAssets={setAssets}
          />
        );
      case "Asset Tracking":
        return (
          <AssetTracking
            assets={assets}
            updateTrackedAssetCount={updateTrackedAssetCount}
          />
        );
      case "Staff":
        return <Staff />;
      case "Users":
        return <Users />;

      default:
        return <Dashboard />;
    }
  };

  return <div>{renderActiveTab()}</div>;
};

export default MainContent;
